import { render, staticRenderFns } from "./CustomerSaleOrder.vue?vue&type=template&id=2d438890&"
import script from "./CustomerSaleOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerSaleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports